<template>
    <div>
        <div class="mobile-overlay" v-if="isMobile">
            <div>
                <HeaderGuest :is-mobile="true"/>
            </div>
            <div class="background-container py-5 text-center">
                <h2 class="heading text-center px-3">
                    #1 Platform for<br>
                    Cross-Promotion
                </h2>
                <h4 class="sub-heading text-center px-4 mx-auto">
                    Wow! Now it is easy to help each other get more backers for your crowdfunding campaigns. Get it done. FOR FREE.
                </h4>
                <div class="card mx-auto text-center">
                    <img src="/img/girlMobile.svg" class="mx-auto mb-4" alt="Girl with laptop">
                    <p class="p3b c6 mx-auto">
                        To access CrossProm switch <br> to your computer browser!
                    </p>
                    <p class="p4 c6o7 mx-auto">
                        CrossProm is dektop-only... yet. Our mobile version will be live soon.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeaderGuest from '../components/HeaderGuest'
export default {
    name: 'MobileView',
    components: {
        HeaderGuest
    },
    data() {
        return {
            isMobile: false
        }
    },
    watch: {
        '$route': 'getWindowWidth'
    },
    mounted() {
        this.$nextTick(function() {
            window.addEventListener('resize', this.getWindowWidth);
            this.getWindowWidth()
        })
    },
    methods: {
        getWindowWidth(event) {
            this.isMobile = document.documentElement.clientWidth < 768 && (this.$route.path !== '/')
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
}
</script>

<style scoped lang="scss">
.mobile-overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    overflow-y: scroll;
    background: url(https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2FParallax%2FGroup%208.png?alt=media&token=c712499f-5672-4d55-bf25-c8ee69adb921) no-repeat;
    background-size: cover;
    overflow: hidden;
}
    .background-container  {
        padding-bottom: 40px;
        min-height: calc(100vh - 60px);
        .heading {
            font-size: 37px;
            font-weight: bold;
            line-height: 115%;
            color: #FFFFFF;
            text-shadow: -2.46154px 1.23077px 0px rgba(14, 40, 94, 0.7);
        }
        .sub-heading {
            font-size: 16px;
            max-width: 400px;
            line-height: 160%;
            color: #B3C3FF;
        }
        .card {
            margin-top: 45px;
            padding: 40px 10px;
            width: 90%;
            max-width: 400px;
            background: #FFFFFF;
            box-shadow: 0 17px 75px rgba(0, 0, 0, 0.07), 0 6.20528px 27.3762px rgba(0, 0, 0, 0.0482987), 0 3.01255px 13.2907px rgba(0, 0, 0, 0.0389404), 0 1.47681px 6.51533px rgba(0, 0, 0, 0.0310596), 0 0.583932px 2.57617px rgba(0, 0, 0, 0.0217013);
            border-radius: 20px;

            p{
                line-height: 140%;
                max-width: 300px;
            }
        }
    }
</style>